(function() { window.GUID_d26c3b13_5d24_4bec_9171_dad6bf90dbea = { getGuid: function() { return "d26c3b13-5d24-4bec-9171-dad6bf90dbea"; } }; })();
var CompuSport;
(function (CompuSport) {
    function GetCookie(cookieName) {
        return $.cookie('CSCookie.' + cookieName);
    }
    CompuSport.GetCookie = GetCookie;
    function SetCookie(cookieName, value) {
        $.removeCookie('CSCookie.' + cookieName);
        $.cookie('CSCookie.' + cookieName, value, { expires: 365, path: '/' });
    }
    CompuSport.SetCookie = SetCookie;
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=Cookie.js.map
